import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth_token: localStorage.getItem('auth_token') || '',
  },
  mutations: {
    token(state) {
      state.auth_token = localStorage.getItem('auth_token')
    },
  },
  actions: {
  },
  modules: {
  }
})
